import axios from 'axios';
import * as types from '@/store/mutation-types';
import {Form} from '@/plugins/FWForms/index';
import {cloneDeep, get, uniqBy} from 'lodash';

export interface AutomationsState {
    loading: Record<string, boolean>;
    form: Form<any>;
    automationUnits: any[];
    eventTypes: any[];
    currentEvent: any;
    currentEventOriginal: any;
    messageTemplates: any[];
    events: any[];
    currentPageEvents: any;
    eventsMeta: any;
    eventMeta: any;
    eventLogs: any[];

}

// state
const state: AutomationsState = {
    loading: {
        messageTemplate: false,
        triggered: false,
        upcoming: false,
        other: false,
        update: false,
        cancel: false,
        logs: false,
        sendNow: false,
        delete_automation: false,
        pause_automation: false,
    },
    form: new Form(),
    automationUnits: [
        {
            name: 'Minutes',
            code: 'minutes',
        },
        {
            name: 'Hours',
            code: 'hours',
        },
        {
            name: 'Days',
            code: 'days',
        },
        {
            name: 'Weeks',
            code: 'weeks',
        },
    ],
    eventTypes: [
        {
            label: 'Pre-trip Photos Rule',
            value: 'photos_rule',
            disabled: true,
            comingSoon: true,
        },
        {
            label: 'Booking Request',
            value: 'booking_request',
        },
        {
            label: 'Trip Booked',
            value: 'trip_booked',
        },
        {
            label: 'Start of Trip',
            value: 'start_of_trip',
        },
        {
            label: 'Halfway Point',
            value: 'halfway',
        },
        {
            label: '3/4 Point',
            value: '3_4',
        },
        {
            label: 'End of Trip',
            value: 'end_of_trip',
        },
        {
            label: 'Post-rental',
            value: 'post_rental',
        },
    ],
    currentEvent: {},
    currentEventOriginal: {},
    messageTemplates: [],
    events: [],
    currentPageEvents: {
        upcoming: [],
        triggered: [],
        other: [],
    },
    eventsMeta: {
        current_page: 0,
    },
    eventMeta: {
        upcoming: {
            current_page: 0,
            per_page: 100,
        },
        triggered: {
            current_page: 0,
            per_page: 100,
        },
        other: {
            current_page: 0,
            per_page: 100,
        },
    },
    eventLogs: [],
};

const getters = {
    loading: state => state.loading,
    eventTypes: state => state.eventTypes,
    messageTemplates: state => state.messageTemplates,
    currentEvent: state => state.currentEvent,
    currentEventOriginal: state => state.currentEventOriginal,
    automationUnits: state => state.automationUnits,
    automationForm: state => state.form,
    events: state => state.events,
    currentPageEvents: state => state.currentPageEvents,
    eventsMeta: state => state.eventsMeta,
    eventMeta: state => state.eventMeta,
    eventLogs: state => state.eventLogs,
};

const mutations = {
    [types.SET_AUTOMATION_LOADING](state, loading) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_MESSAGE_TEMPLATES](state, messageTemplates) {
        state.messageTemplates = messageTemplates;
    },
    [types.SET_CURRENT_AUTOMATION_EVENT](state, event) {
        state.currentEventOriginal = cloneDeep(event);
        state.currentEvent = event;
    },
    [types.SET_AUTOMATION_EVENTS](state, events) {
        state.currentPageEvents[events.type] = events.data.data;
        state.events = uniqBy([...state.events, ...events.data.data], w => w.uuid);

        delete events.data.data;
        delete events.data.links;
        state.eventMeta[events.type] = events.data;
    },
    [types.SET_CURRENT_EVENT_LOGS](state, logs) {
        state.eventLogs = logs;
    },
};

const actions = {

    /**
     * Fetch automations
     *
     * @param commit
     */
    fetchAutomations({commit}) {
        axios.get('/v1/automations')
            .then((response) => {
                commit('SET_MESSAGE_TEMPLATES', get(response, 'data.automations', []));
            }).catch(() => {
        }).finally(() => {
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
